<template>
  <el-dialog :visible.sync="visible" class="banner-pager-dialog" width="800px" :canResize="false" :showFullScreenButton="false">
    <div slot="title" class="bss-banner-history-pager-title">
      <p class="el-dialog__title">{{ currentPage.name }}</p>
      <BssPager v-model="currentPageId" :data="pageData" @change="onPagerChange"/>
    </div>
    <div class="kye-dialog-body" @click="onClick">
      <div class="play-btn" v-if="showPlayBtn"><div class="triangle"></div></div>
      <img :src="currentPage.iconUrlV2 || currentPage.iconUrlNew" alt="" />
    </div>
  </el-dialog>
</template>

<script>
  import {isBannerImg} from './utils'
  import BssPager from '../bss-pager/index.vue'
  // const BssPager =
  export default {
    components: {
      BssPager,
    },
    data() {
      return {
        visible: false,
        currentPageId: '',
        currentPage: {
          id: '',
          name: '',
          iconUrlNew: '',
        },
        pageData: [],
      }
    },
    computed: {
      showPlayBtn () {
        return this.currentPage.id && !isBannerImg(this.currentPage)
      }
    },
    methods: {
      open (row, list) {
        this.pageData = list
        this.currentPageId = row.id
        this.onPagerChange(row)
        this.visible = true
      },
      onPagerChange (row) {
        this.currentPage = row
        this.$emit('page-change', this.currentPage)
      },
      onClick () {
        this.$emit('click', this.currentPage)
      }
    }
  }
</script>

<style lang="scss" scoped>
.banner-pager-dialog {
  .bss-banner-history-pager-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 66px);
    height: 100%;
  }
  .kye-dialog-body {
    min-height: 100px;
    position: relative;
  }
  img {
    display: block;
    width: 100%;
    cursor: pointer;
  }
  .play-btn {
    cursor: pointer;
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    z-index: 101;
    background: rgba(0, 0, 0, 0.5);
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    .triangle {
      width: 0;
      height: 0;
      border-top: 8px solid transparent;  /* 左边透明 */
      border-bottom: 8px solid transparent; /* 右边透明 */
      border-left: 12px solid #fff;  /* 底边白色，高度通过勾股定理计算获得 */
      margin-left: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/banner/pager-dialog.vue